import * as React from 'react';
import HeaderFlexPane from './HeaderFlexPane';
import HeaderPaneProps from './HeaderPaneProps';
import { observer } from 'mobx-react';
import { GetStartedTaskContainer } from 'owa-get-started';
import strings from 'owa-strings/owa-getstarted-strings';
import { logUsage } from 'owa-analytics';

@observer
export default class GetStartedPane extends React.Component<HeaderPaneProps, {}> {
    constructor(props: HeaderPaneProps) {
        super(props);
    }

    componentDidMount() {
        logUsage('getStartedPaneOpened', null, { isCore: true });
    }

    render() {
        return (
            <HeaderFlexPane
                title={strings.getStarted_FlexPane_Title}
                content={<GetStartedTaskContainer />}
                onDismiss={() => {
                    this.props.onDismiss();
                }}
            />
        );
    }
}
